import type { DbEvent } from "shared/types/Messages";
import { messagingConfig } from "shared/types/Messages";

import useDBEvents from "./useDBEvents";

const useMessagingDBEvents = () => useDBEvents<DbEvent>(messagingConfig.broadcastChannel);

export default useMessagingDBEvents;
